import React, { useState, useContext, useEffect } from 'react';
import { ThemeContext } from 'context/themeContext';
import Input from 'components/input';
import Modal from 'components/modal';
import LoginForm from './components/login';
import RegisterForm from './components/register';
import MainContext from '../../MainContext';
import { Wrapper } from 'components/wrapper';
import Button from 'components/button';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { validateEmail, validateName } from 'utils/validators';
import OTPPage from 'containers/otp/index';
import { useTranslation } from 'react-i18next';

const Title = styled.div`
  position: Relative;
  color: ${(props) => props.theme.textPrimary};
  font-size: 1.25vw;
  margin-bottom: 3.8vw;
`;

const Login = (props) => {
  const {
    loginState,
    setLoginState,
    checkUserRegisteredContext,
    loginWithPasswordContext,
    registerContext,
    redirect,
    forgetPasswordContext,
  } = useContext(MainContext).login;
  const { theme } = useContext(ThemeContext);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [registerPassword, setRegisterPassword] = useState('');
  const [acceptRules, setAcceptRules] = useState(false);
  const [emailValidator, setEmailValidator] = useState(true);
  const [registerPasswordValidator, setRegisterPasswordValidator] = useState(true);
  const { t } = useTranslation();

  const { open, toggle, guest, guestId,skipable=false } = props;

  useEffect(() => {
    if (redirect.length > 0) {
      setLoginState(4);
    }
  }, [redirect]);

  const onChange = (key, value) => {
    if (key === 'email') {
      if (loginState !== 1) {
        setLoginState(1);
      }
      setEmail(value);
    }
    if (key === 'password') {
      setPassword(value);
    }
    if (key === 'first-name') {
      if (validateName(value)) setFirstName(value);
    }
    if (key === 'Last-name') {
      if (validateName(value)) setLastName(value);
    }
    if (key === 'register-password') {
      if (value.length < 6) {
        setRegisterPasswordValidator(false);
      } else {
        setRegisterPasswordValidator(true);
      }
      setRegisterPassword(value);
    }
  };
  const onClick = () => {
    if (loginState === 1) {
      if (validateEmail(email)) {
        checkUserRegisteredContext(email);
        setEmailValidator(true);
      } else {
        setEmailValidator(false);
      }
    }
    if (loginState === 2 && password) {
      loginWithPasswordContext({ cellphone: email, password, guest, guest_id: guestId });
    }
    if (loginState === 3 && acceptRules) {
      registerContext({
        cellphone: email,
        password: registerPassword,
        password2: registerPassword,
        first_name: firstName,
        last_name: lastName,
      });
    }
  };
  const onForgetPasswordClick = () => {
    forgetPasswordContext(email);
  };
  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onClick();
    }
  };
  const onCheckboxClick = () => {
    setAcceptRules(!acceptRules);
  };

  return (
    <Modal open={open} toggle={() => (skipable) && toggle(false)}>
      {loginState !== 4 ? (
        <Wrapper modalStatus={true} style={{ paddingBottom: '3.982vw', paddingTop: '3.982vw' }}>
          <Title theme={theme}>
            {loginState === 1
              ? t('login.form.Enter your email Address')
              : loginState === 2
              ? t('login.form.Login')
              : t('login.form.Register')}
          </Title>
          <div onClick={() => setLoginState(1)}>
            <Input
              autofocus="true"
              placeholder={t('login.form.email')}
              onChange={onChange}
              inputTarget="email"
              value={email}
              onKeyDown={onKeyDown}
              size="larg"
              validate={emailValidator}
              errMsg={t('login.form.Enter the valid mail address')}
            />
          </div>
          <LoginForm
            loginState={loginState}
            onChange={onChange}
            password={password}
            onKeyDown={onKeyDown}
            onForgetPasswordClick={onForgetPasswordClick}
          />
          <RegisterForm
            loginState={loginState}
            onChange={onChange}
            registerPassword={registerPassword}
            firstName={firstName}
            lastName={lastName}
            acceptRules={acceptRules}
            onCheckboxClick={onCheckboxClick}
            onKeyDown={onKeyDown}
            registerPasswordValidator={registerPasswordValidator}
          />
          <Button
            onClick={onClick}
            marginTop={2.08}
            text={
              loginState === 3
                ? t('login.form.Register')
                : loginState === 2
                ? t('login.form.Login')
                : t('login.form.Next')
            }
            size="larg"
            deActive={
              (loginState === 3 &&
                (!acceptRules || !firstName || !lastName || registerPassword.length < 6)) ||
              (loginState === 2 && !password)
            }
          />
        </Wrapper>
      ) : (
        <OTPPage modalStatus={true} guest={guest} guestId={guestId} />
      )}
    </Modal>
  );
};

export default Login;
